import { render } from "./RequiredReadingModal.vue?vue&type=template&id=060e8e18&scoped=true"
import script from "./RequiredReadingModal.vue?vue&type=script&lang=js"
export * from "./RequiredReadingModal.vue?vue&type=script&lang=js"

import "./RequiredReadingModal.vue?vue&type=style&index=0&id=060e8e18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060e8e18"]])

export default __exports__